"use client";

import {
  OpenFeatureProvider as ReactOpenFeatureProvider,
  OpenFeature,
} from "@openfeature/react-sdk";
import { webFlagProvider, buildFlagContext } from "@sa-nu/flags/web";
import { useEffect, type ReactNode } from "react";

// OpenFeature client を初期化（Web SDK 用の provider を使用）
OpenFeature.setProvider(webFlagProvider);

/**
 * OpenFeature Provider Wrapper
 *
 * フィーチャーフラグシステムを初期化し、アプリケーション全体で利用可能にする
 */
export function OpenFeatureProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    // TODO: Auth0のJWTにuserIdを含めておくことで、Feature Flag用のContextを追加できるようになるはず。
    // 設定がうまくいけば、ここでuserIdを渡す。

    // Context Builder でユーザーコンテキストを構築
    const context = buildFlagContext().withUser({ userId: null }).build();

    // OpenFeature の context を更新
    OpenFeature.setContext(context);
  }, []);

  return <ReactOpenFeatureProvider>{children}</ReactOpenFeatureProvider>;
}
